<breadcrumb [items]="breadcrumb" />

<div *ngIf="loading.main" class="text-center my-5">
    <div class="spinner-border" role="status"></div>
</div>

@if (!loading.main && inactive) {
<div class="card border-0 bg-body-tertiary shadow-sm">
    <div class="card-body d-flex align-items-center justify-content-between gap-3">
        <div class="d-flex align-items-center gap-3">
            <i class="bi bi-info-circle text-primary fs-4"></i>
            <div>
                <h1 class="h5 mb-1">Nenhuma consulta em andamento</h1>
                <div class="text-body-secondary">A consulta não está ativa ou já foi finalizada.</div>
            </div>
        </div>
        <a class="btn btn-primary" routerLink="/consultations">Voltar</a>
    </div>
</div>
}

@if (!loading.main && consultation && !inactive) {
<div class="d-flex align-items-center justify-content-between mb-3">
    <div>
        <h1 class="mb-1">Consulta em andamento</h1>
        <div class="text-body-secondary">Atualização automática enquanto a gravação segue ativa.</div>
    </div>
    <span class="badge text-bg-success">Ao vivo</span>
</div>

<div class="card border-0 bg-body-tertiary shadow-sm mb-3">
    <div class="card-body">
        <div class="row g-3 align-items-center">
            <div class="col-12 col-md-4">
                <label class="text-body-tertiary">Paciente</label>
                <div class="fw-medium">{{ patientName }}</div>
            </div>
            <div class="col-6 col-md-2">
                <label class="text-body-tertiary">Sexo</label>
                <div>{{ patientSex }}</div>
            </div>
            <div class="col-12 col-md">
                <label class="text-body-tertiary">Status</label>
                <div class="mt-1" [innerHTML]="getScore(consultation.gravidade1a5)"></div>
            </div>
        </div>
    </div>
</div>

<ul class="nav nav-tabs mx-md-n4 px-md-4" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="live-data" data-bs-toggle="tab" data-bs-target="#live-data-pane"
            type="button" role="tab">Dados clínicos</button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="live-transcriptions" data-bs-toggle="tab"
            data-bs-target="#live-transcriptions-pane" type="button" role="tab">
            Transcrição
            <span class="spinner-border spinner-border-sm ms-1" role="status" *ngIf="loading.transcriptions"></span>
        </button>
    </li>
</ul>

<div class="tab-content mt-4">
    <div class="tab-pane fade show active" id="live-data-pane" role="tabpanel" tabindex="0">
        <div class="card border-0 bg-body-tertiary shadow-sm">
            <div class="card-header d-flex align-items-center justify-content-between">
                <h5 class="card-title fw-lighter mb-0">Dados processados</h5>
                <span class="badge text-bg-light" *ngIf="socketUnavailable">Socket indisponível</span>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <label class="text-body-tertiary">Queixa Principal</label>
                    @let queixaPrincipalValue = getProcessedFieldValue("queixaPrincipal");
                    @if (isFieldAnnotating("queixaPrincipal")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(queixaPrincipalValue)) {
                    <ul class="ps-3">
                        @for (item of queixaPrincipalValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    <p>{{ queixaPrincipalValue }}</p>
                    }
                </div>
                <div class="mb-3">
                    <label class="text-body-tertiary">História da Doença</label>
                    @let historiaDaDoencaValue = getProcessedFieldValue("historiaDaDoenca");
                    @if (isFieldAnnotating("historiaDaDoenca")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(historiaDaDoencaValue)) {
                    <ul class="ps-3">
                        @for (item of historiaDaDoencaValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    <p>{{ historiaDaDoencaValue }}</p>
                    }
                </div>
                <div class="mb-3">
                    <label class="text-body-tertiary">Antecedentes Pessoais/Familiares</label>
                    @let antecedentesValue = getProcessedFieldValue("antecedentesPessoaisFamiliares");
                    @if (isFieldAnnotating("antecedentesPessoaisFamiliares")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(antecedentesValue)) {
                    <ul class="ps-3">
                        @for (item of antecedentesValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    <p>{{ antecedentesValue }}</p>
                    }
                </div>
                <div class="mb-3">
                    <label class="text-body-tertiary">Medicação de Uso Contínuo</label>
                    @let medicacaoValue = getProcessedFieldValue("medicacaoUsoContinuo");
                    @if (isFieldAnnotating("medicacaoUsoContinuo")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(medicacaoValue)) {
                    <ul class="ps-3">
                        @for (item of medicacaoValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    <p>{{ medicacaoValue }}</p>
                    }
                </div>
                <div class="mb-3">
                    <label class="text-body-tertiary">Hipótese Diagnóstica</label>
                    @let hipotesesValue = getProcessedFieldValue("hipotesesDiagnostica");
                    @if (isFieldAnnotating("hipotesesDiagnostica")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(hipotesesValue)) {
                    <ul class="ps-3">
                        @for (item of hipotesesValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    <p>{{ hipotesesValue }}</p>
                    }
                </div>
                <div class="mb-3">
                    <label class="text-body-tertiary">Conduta Médica</label>
                    @let condutaValue = getProcessedFieldValue("condutaMedica");
                    @if (isFieldAnnotating("condutaMedica")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(condutaValue)) {
                    <ul class="ps-3">
                        @for (item of condutaValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    @if (condutaValue.includes("[RESUMO_CONDUTA]") &&
                    condutaValue.includes("[DESCRICAO_COMPLETA_CONDUTA]")) {
                    <ul class="ps-3">
                        <li><strong>Resumo:</strong> {{
                            condutaValue.split("[RESUMO_CONDUTA]")[1].split("[/RESUMO_CONDUTA]")[0].trim() }}</li>
                        <li><strong>Conduta completa:</strong> {{
                            condutaValue.split("[DESCRICAO_COMPLETA_CONDUTA]")[1].split("[/DESCRICAO_COMPLETA_CONDUTA]")[0].trim()
                            }}</li>
                    </ul>
                    } @else {
                    <p>{{ condutaValue }}</p>
                    }
                    }
                </div>
                <div class="mb-3">
                    <label class="text-body-tertiary">Sugestão</label>
                    @let insightValue = getProcessedFieldValue("insightNaoFeito");
                    @if (isFieldAnnotating("insightNaoFeito")) {
                    <p class="annotation-placeholder">
                        <i class="bi bi-pen"></i>
                        <span>Anotando...</span>
                    </p>
                    } @else if (isProcessedFieldList(insightValue)) {
                    <ul class="ps-3">
                        @for (item of insightValue; track $index) {
                        <li>{{ item }}</li>
                        }
                    </ul>
                    } @else {
                    <p>{{ insightValue }}</p>
                    }
                </div>
                <div>
                    <label class="text-body-tertiary" for="physicalExam">Exame Físico</label>
                    <div class="text-body-secondary fs-7 mb-2">
                        Insira aqui os valores aferidos no exame físico. Pressão, temperatura, etc
                    </div>
                    <textarea id="physicalExam" name="physicalExam" class="form-control bg-body-secondary border-0"
                        rows="4" [ngModel]="physicalExamInput" (ngModelChange)="onPhysicalExamInputChange($event)"
                        [disabled]="loading.physicalExam"></textarea>
                    <button type="button" class="btn btn-outline-secondary mt-3 px-4"
                        [disabled]="loading.physicalExam || !physicalExamInput.trim()" (click)="savePhysicalExam()">
                        <span class="spinner-border spinner-border-sm me-1" role="status"
                            *ngIf="loading.physicalExam"></span>
                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="live-transcriptions-pane" role="tabpanel" tabindex="0">
        <ul class="list-group" *ngIf="transcriptions.length; else emptyTranscriptions">
            <li class="list-group-item py-3" *ngFor="let transcription of transcriptions; trackBy: trackTranscription">
                <div class="d-flex align-items-center mb-2">
                    <div class="icon-letter bg-warning-subtle text-warning-emphasis me-2"
                        *ngIf="transcription.issuer === 'patient'">P</div>
                    <div class="icon-letter bg-primary-subtle text-primary me-2"
                        *ngIf="transcription.issuer === 'doctor'">M</div>
                    <div class="fw-bold fs-7 text-dark-emphasis">
                        {{ transcription.issuer === "patient" ? "Paciente" : "Médico" }}
                    </div>
                    <small class="text-body-tertiary ms-2">{{ transcription.created_at | date: "HH:mm:ss" }}</small>
                </div>
                <div class="text-body-secondary fs-7">
                    {{ transcription.transcript_text }}
                </div>
            </li>
        </ul>
        <ng-template #emptyTranscriptions>
            <div class="card border-0 bg-body-tertiary shadow-sm">
                <div class="card-body text-body-secondary">Aguardando transcrições da consulta.</div>
            </div>
        </ng-template>
    </div>
</div>
}